module.exports = __webpack_public_path__ + "media/images/vip-a8aff2288c4629819ac31bbdf48eb521.svg";